import React from 'react';
import PointMapComponent from '../components/PointMap';

export default class PointMapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  async componentDidMount() {
    await this._loadGpxData();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      await this._loadGpxData();
    }
  }

  async _loadGpxData() {
    if (!this.props.url || this.state.loading === true) return;

    this.setState({ loading: true });
    this.props.toggleLoading();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_FETCH_URL}?url=${this.props.url}`
      );
      const data = await response.json();

      this.setState({ data, error: false, loading: false });
      this.props.setRouteName(data.routes[0].name);
    } catch (e) {
      this.setState({ loading: false, error: true, message: e.message });
    }

    this.props.toggleLoading();
  }

  render() {
    if (!this.props.url) return null;
    if (this.state.loading) return <>Loading...</>;
    if (this.state.error)
      return (
        <div className="container mt-4">
          <div className="alert alert-danger">Unable to load GPX file</div>
        </div>
      );

    return (
      <PointMapComponent
        data={this.state.data}
        showWaypoints={this.props.showWaypoints}
      />
    );
  }
}
